/**
 * documentation at
 * https://webartelier.de/fee_doc/list_functions.html#getviewport
 */
var feeJS = feeJS || {};
feeJS.getViewport = () => {
  const scope = document.body;
  return feeJS.getCssCustomProperty(scope, '--vp-name');
}



/**
 * documentation at
 * https://webartelier.de/fee_doc/list_functions.html#isviewportorup
 */

feeJS.isViewportOrUp = (checkedViewport) => {
  const viewports = [
    'tiny',
    'small',
    'medium',
    'large',
    'xxl'
  ];

  if (!viewports.includes(checkedViewport)) {
    console.warn(`'${checkedViewport}' is not a viewport!`);
    return false;
  }

  const currentViewport = feeJS.getViewport();
  const currentIndex = viewports.indexOf(currentViewport);
  const checkedViewportIndex = viewports.indexOf(checkedViewport);

  return currentIndex >= checkedViewportIndex;
}